.filtros {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--s-4);
}
.busqueda {
  width: 300px;
}
.espacio {
  flex: 1;
}
.cifra {
  font-family: var(--font-mono);
  color: var(--text-strong);
}
.lote {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--s-4);
}
.nombre {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.enlace {
  font-weight: var(--fw-semibold);
  color: var(--text-strong);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.enlace:hover {
  color: var(--text-link);
}
@media (max-width: 767px) {
  .busqueda {
    width: 100%;
  }
}
.telefono {
  white-space: nowrap;
}
